import Cookie from 'js-cookie'
const Data = {
  state: {
     biddenData:{},     //叫价的拍品信息
     biddenPopup:false, //叫价选项卡的显隐标记
     //选择完地址后，把选择的地址存放起来
     deliveryAddr:{},
     //商品类型，0：普通商品，1：限时商品，2：预售商品，3：团购商品，4：摇号商品
     mallDetailType: 0,     //用于记录商品详情页是否为活动商品，是什么活动 0：代表是无活动
     //优化前端本地数据模型
     userSeq: Cookie.get('userSeq'),   //用户seq
     postList:[
       [],    //正在分享帖子数据
       [],   //历史分享提日子数据
       [],   //酒评帖子数据
     ],
  },
  mutations: {
  	//存放出价拍品的数据
    setBiddenData (state, data) {
      state.biddenData = data
    },
    //设置出价弹窗的显隐标记
    setBiddenPopup (state, blo) {
      state.biddenPopup = blo
    },
    //存放选择完地址后存放选中的地址
     setDeliveryAddr (state, item) {
      state.deliveryAddr = item
    },
    //商品类型，0：普通商品，1：限时商品，2：预售商品，3：团购商品，4：摇号商品
     setMallDetailType (state, type) {
      state.mallDetailType = type
    },
    //帖子数据赋值(赋值单种类型)    type帖子列表类型   0---正在分享，1---历史分享    2---酒评帖子
    setPostData (state, data){
        state.postList[data.type] = data.list;
    },
    //帖子数据赋值 （所有类型一起赋值）
    upPostData (state, list){
      state.postList= list;
    }
  },
  actions: {
  }
}

export default Data



// WEBPACK FOOTER //
// ./src/store/modules/data.js